<template>
  <div class="app-layout">
    <Sidebar :class="{ 'open': isSidebarOpen }" @toggle-sidebar="toggleSidebar" />
    <div class="main-content" :class="{ 'sidebar-open': isSidebarOpen }">
      <div class="header">
        <div class="header-left">
          <button class="menu-toggle" @click="toggleSidebar" aria-label="Toggle Menu">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M3 12h18M3 6h18M3 18h18"/>
            </svg>
          </button>
          <h1>Create New Assessment Option</h1>
        </div>
      </div>
      
      <form @submit.prevent="submitAssessmentOption" class="create-form">
        <div class="form-group">
          <label>Question ID:</label>
          <input type="number" v-model.number="formData.question_id" required>
        </div>
        
        <div class="form-group">
          <label>English Value:</label>
          <input type="text" v-model="formData.value" required>
        </div>
        
        <div class="form-group">
          <label>Arabic Value:</label>
          <input type="text" v-model="formData.value_ar">
        </div>
        
        <div class="form-group">
          <label>Order:</label>
          <input type="number" v-model.number="formData.order" required>
        </div>
        
        <button type="submit" :disabled="isSubmitting">
          {{ isSubmitting ? 'Submitting...' : 'Create Option' }}
        </button>
        
        <div v-if="error" class="error">{{ error }}</div>
        <div v-if="success" class="success">Option created successfully!</div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Sidebar from '@/components/Sidebar.vue'

export default {
  name: 'CreateAssessmentOption',
  components: {
    Sidebar
  },
  data() {
    return {
      formData: {
        question_id: '',
        value: '',
        value_ar: '',
        order: ''
      },
      success: false,
      isSidebarOpen: false
    }
  },
  computed: {
    ...mapGetters(['isLoading', 'errorMessage']),
    isSubmitting() {
      return this.isLoading
    },
    error() {
      return this.errorMessage
    }
  },
  methods: {
    ...mapActions(['createAssessmentOption', 'addNotification', 'toggleSidebar']),
    
    async submitAssessmentOption() {
      try {
        const optionData = {
          question_id: Number(this.formData.question_id),
          value: this.formData.value,
          value_ar: this.formData.value_ar,
          order: Number(this.formData.order)
        }
        
        await this.createAssessmentOption(optionData)
        
        // Reset form and show success
        this.formData = {
          question_id: '',
          value: '',
          value_ar: '',
          order: ''
        }
        
        this.success = true
        
        this.addNotification({
          type: 'success',
          message: 'Assessment option created successfully'
        })
        
        // Redirect after success
        setTimeout(() => {
          this.$router.push({ name: 'AssessmentOptions' })
        }, 1500)
        
      } catch (error) {
        this.addNotification({
          type: 'error',
          message: `Failed to create assessment option: ${error.message}`
        })
      }
    }
  }
}
</script>

<style scoped>
.app-layout {
  display: flex;
  min-height: 100vh;
  background-color: #f8f9fa;
}

.main-content {
  flex: 1;
  margin-left: 280px;
  padding: 2rem;
  transition: margin-left 0.3s ease;
}

.header {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.menu-toggle {
  display: none;
  background: none;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
  color: #2c3e50;
}

.menu-toggle svg {
  width: 24px;
  height: 24px;
}

/* Keep the same form styles */
.create-form {
  margin-bottom: 3rem;
  padding: 2rem;
  background: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: #64748b;
}

.form-group input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.375rem;
  font-size: 1rem;
}

button[type="submit"] {
  background-color: #3b82f6;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

button[type="submit"]:disabled {
  background-color: #94a3b8;
  cursor: not-allowed;
}

.success {
  color: #22c55e;
  margin-top: 1rem;
}

.error {
  color: #ef4444;
  margin-top: 1rem;
}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
    padding: 1rem;
  }

  .menu-toggle {
    display: block;
  }

  .main-content.sidebar-open {
    margin-left: 280px;
  }
}
</style> 